import Fill from 'ol/style/Fill';
import FontSymbol from 'ol-ext/style/FontSymbol';
import {replaceTextPlaceholder} from '/src/modules/language/language';
import Stroke from 'ol/style/Stroke';
import Text from 'ol/style/Text';
import Style from 'ol/style/Style';

/**
 * Function for styling a lineString
 * @param {object} feature
 * @param {number} resolution
 * @return {*}
 */
export function stylePoint(feature, resolution) {
  let text;
  let style;
  let fontSize = 12;

  if (feature.get('type') === 'Marker') {
    if (resolution < 0.4) {
      text = new Text({
        font: feature.get('marker')['font']['weight'] + ' ' + feature.get('marker')['font']['size'] / resolution + ' "' + feature.get('marker')['font']['family'] + '"',
        text: feature.get('marker')['symbol']['content'],
        // offsetY: -8,
        placement: 'point',
        textAlign: 'center',
        textBaseline: 'middle',
        fill: new Fill({
          color: feature.get('marker')['symbol']['color'],
        }),
        maxResolution: feature.get('maxResolution'),
        rotateWithView: false,
      });
      style = new Style();

      if (feature.get('marker')['form'] !== null) {
        let image = new FontSymbol({
          form: feature.get('marker')['form']['type'],
          glyph: '',
          fontSize: 0.6 / resolution,
          radius: 19 / resolution,
          offsetX: feature.get('marker')['form']['offsetX'] !== null ? feature.get('marker')['form']['offsetX'] : 0,
          offsetY: feature.get('marker')['form']['offsetY'] !== null ? feature.get('marker')['form']['offsetY'] : 0,
          rotateWithView: false,
          color: '#fff',
          fill: new Fill({
            color: feature.get('marker')['color'],
          }),
          stroke: new Stroke({
            color: '#666',
            width: 1,
          }),
        });
        style.setImage(image);
        style.setText(text);
      } else {
        text.setFont(feature.get('marker')['font']['weight'] + ' ' + feature.get('marker')['font']['size'] / resolution + 'px "' + feature.get('marker')['font']['family'] + '"');
        style.setText(text);
      }
    }
  } else if (feature.get('type') === 'TextPoint') {
    if (resolution < 0.4) {
      let featureText = feature.get('text');

      featureText = replaceTextPlaceholder(featureText);
      text = new Text({
        text: featureText,
        font: fontSize + 2 + 'px sans-serif',
        fill: new Fill({
          color: '#000000',
        }),
        placement: 'point',
        textAlign: 'center',
        rotation: typeof feature.get('align') !== 'undefined' ? (feature.get('align') === 'left' ? 90 * (Math.PI / 180) : 90 * (-Math.PI / 180)) : 0,
        rotateWithView: false,
        overflow: true,
        textBaseline: 'top',
      });
      style = new Style();

      style.setText(text);
    }
  }
  return style;
}
